import request from '../utils/request'

export function getList (data) {
    return request({
        url: '/api/questions',
        method: 'get',
        params: data
    })
}
export function getRands (data) {
    return request({
        url: '/api/questions/rands',
        method: 'get',
        params: data
    })
}

export function getQuestionList() {
    return request({
        url: '/api/questions/rands',
        method: 'get',
    })
}
